import {
  createRootRoute,
  createRoute,
  createRouter,
  Outlet,
  redirect,
} from '@tanstack/react-router';
import { AuthLayout } from '../components/layout/auth-layout';
import { LoginPage } from '../pages/login/login-page';
import { CasesPage } from '../pages/cases/cases-page';
import { CaseRoomPage } from '../pages/case-room/case-room-page';
import { CaseStoryPage } from '../pages/case-story/case-story-page';
import { AdminPage } from '../pages/admin/admin-page';
import { validateCaseRoomSearch, validateCaseStorySearch } from './search-params';

const rootRoute = createRootRoute({
  component: () => <Outlet />,
});

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: () => {
    throw redirect({ to: '/cases' });
  },
});

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: LoginPage,
});

const authLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: '_auth',
  component: AuthLayout,
});

const casesRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/cases',
  component: CasesPage,
});

const caseRoomRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/cases/$caseId',
  validateSearch: validateCaseRoomSearch,
  component: CaseRoomPage,
});

const caseStoryRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/cases/$caseId/story',
  validateSearch: validateCaseStorySearch,
  component: CaseStoryPage,
});

const adminRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/admin',
  component: AdminPage,
});

const routeTree = rootRoute.addChildren([
  indexRoute,
  loginRoute,
  authLayoutRoute.addChildren([casesRoute, caseRoomRoute, caseStoryRoute, adminRoute]),
]);

export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export { caseRoomRoute, caseStoryRoute };
